var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useMemo } from "react";
import ElectionStats from "./ElectionStats";
import { useQuery } from "@apollo/client";
import { useRecordContext } from "react-admin";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { IPermissions } from "@/types/keycloak";
import { GET_ELECTION_MONITORING } from "@/queries/GetElectionMonitoring";
var MonitoringDashboardElection = function () {
    var record = useRecordContext();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _a = useQuery(GET_ELECTION_MONITORING, {
        variables: {
            electionEventId: record === null || record === void 0 ? void 0 : record.election_event_id,
            electionId: record === null || record === void 0 ? void 0 : record.id,
        },
        pollInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
        context: {
            headers: {
                "x-hasura-role": IPermissions.MONITORING_DASHBOARD_VIEW_ELECTION,
            },
        },
    }), loading = _a.loading, dataStats = _a.data, doRefetch = _a.refetch;
    var data = useMemo(function () { return dataStats === null || dataStats === void 0 ? void 0 : dataStats.get_election_monitoring; }, [dataStats]);
    var stats = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        return {
            eligibleVotersCount: (_a = data === null || data === void 0 ? void 0 : data.total_eligible_voters) !== null && _a !== void 0 ? _a : "-",
            enrolledVotersCount: (_b = data === null || data === void 0 ? void 0 : data.total_enrolled_voters) !== null && _b !== void 0 ? _b : "-",
            votedCount: (_c = data === null || data === void 0 ? void 0 : data.total_voted) !== null && _c !== void 0 ? _c : "-",
            authenticationStats: {
                authenticatedCount: (_e = (_d = data === null || data === void 0 ? void 0 : data.authentication_stats) === null || _d === void 0 ? void 0 : _d.total_authenticated) !== null && _e !== void 0 ? _e : "-",
                notAuthenticatedCount: (_g = (_f = data === null || data === void 0 ? void 0 : data.authentication_stats) === null || _f === void 0 ? void 0 : _f.total_not_authenticated) !== null && _g !== void 0 ? _g : "-",
                invalidUsersErrorsCount: (_j = (_h = data === null || data === void 0 ? void 0 : data.authentication_stats) === null || _h === void 0 ? void 0 : _h.total_invalid_users_errors) !== null && _j !== void 0 ? _j : "-",
                invalidPasswordErrorsCount: (_l = (_k = data === null || data === void 0 ? void 0 : data.authentication_stats) === null || _k === void 0 ? void 0 : _k.total_invalid_password_errors) !== null && _l !== void 0 ? _l : "-",
            },
            approvalStats: {
                approvedCount: (_o = (_m = data === null || data === void 0 ? void 0 : data.approval_stats) === null || _m === void 0 ? void 0 : _m.total_approved) !== null && _o !== void 0 ? _o : "-",
                disapprovedCount: (_q = (_p = data === null || data === void 0 ? void 0 : data.approval_stats) === null || _p === void 0 ? void 0 : _p.total_disapproved) !== null && _q !== void 0 ? _q : "-",
                manualApprovedCount: (_s = (_r = data === null || data === void 0 ? void 0 : data.approval_stats) === null || _r === void 0 ? void 0 : _r.total_manual_approved) !== null && _s !== void 0 ? _s : "-",
                manualDisapprovedCount: (_u = (_t = data === null || data === void 0 ? void 0 : data.approval_stats) === null || _t === void 0 ? void 0 : _t.total_manual_disapproved) !== null && _u !== void 0 ? _u : "-",
                automatedApprovedCount: (_w = (_v = data === null || data === void 0 ? void 0 : data.approval_stats) === null || _v === void 0 ? void 0 : _v.total_automated_approved) !== null && _w !== void 0 ? _w : "-",
                automatedDisapprovedCount: (_y = (_x = data === null || data === void 0 ? void 0 : data.approval_stats) === null || _x === void 0 ? void 0 : _x.total_automated_disapproved) !== null && _y !== void 0 ? _y : "-",
            },
        };
    }, [data]);
    return _jsx("div", { children: data && _jsx(ElectionStats, __assign({}, stats)) });
};
export default MonitoringDashboardElection;
